import { apiRequest } from "./apiService";

const noWorkspaceScope = { workspaceScoped: false };

export const getWorkspaces = () => apiRequest("/workspaces", "GET", null, noWorkspaceScope);
export const createWorkspace = (body) => apiRequest("/workspaces", "POST", body, noWorkspaceScope);
export const updateWorkspace = (workspaceId, body) =>
  apiRequest(`/workspaces/${encodeURIComponent(workspaceId)}`, "PATCH", body, noWorkspaceScope);
export const archiveWorkspace = (workspaceId) =>
  apiRequest(`/workspaces/${encodeURIComponent(workspaceId)}`, "DELETE", null, noWorkspaceScope);
